// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__xBZtZ","container":"style_container__3rzY_","about":"style_about__GA_Ib"};